import { createContext } from 'react';

/** Set by the authenticated session; absent for public pages. */
export const ListingStateOwnerContext = createContext<string | null>(null);
